/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import configurationRulesSlice from './slices/configurationRulesSlice';
import generalSlice from './slices/generalSlice';

const useGlobalStore = create(
  devtools(
    immer(
      (...a) => ({
        ...generalSlice(...a),
        ...configurationRulesSlice(...a),
      }),
      { name: 'GlobalStore' },
    ),
  ),
);

export default useGlobalStore;
